/**
 * Detecta o `@token` ativo no textarea — usado pelo popup de menção para
 * filtrar a lista. Retorna `null` se o caret não estiver dentro de um token
 * de menção em andamento.
 */
export interface MentionContext {
  /** Texto digitado depois do `@`, sem o `@`. */
  query: string
  /** Índice do caractere `@` na string original. */
  startIndex: number
  /** Posição do caret. */
  caretIndex: number
}

export function getActiveMention(
  text: string,
  caret: number,
): MentionContext | null {
  if (caret <= 0) return null
  // Procura `@` mais próximo antes do caret, mas só dentro da mesma "palavra"
  // (sem espaço entre o @ e o caret).
  let i = caret - 1
  while (i >= 0) {
    const ch = text[i]
    if (ch === '@') {
      // O @ é válido se: começo do texto, ou caractere anterior é não-palavra.
      const prev = i > 0 ? text[i - 1] : ''
      const validPrev = !prev || /[\s.,;:!?()[\]{}"'<>]/.test(prev)
      if (validPrev) {
        return {
          query: text.slice(i + 1, caret),
          startIndex: i,
          caretIndex: caret,
        }
      }
      return null
    }
    if (/\s/.test(ch)) return null
    i--
  }
  return null
}

export interface InsertResult {
  text: string
  caret: number
}

export function insertMention(
  text: string,
  context: MentionContext,
  fullName: string,
): InsertResult {
  const before = text.slice(0, context.startIndex)
  const after = text.slice(context.caretIndex)
  const inserted = `@${fullName} `
  return {
    text: before + inserted + after,
    caret: before.length + inserted.length,
  }
}
